/* eslint-disable camelcase */
import React from "react"
import { auditShape } from "utils/propTypeShapes"
import TaskLink from "../TaskLink"

const TaskUserRemovedAuditItemDetails = ({ audit }) => {
  const {
    auditedChanges,
    formSubmissionSlug,
    task,
    taskAssignee,
    taskMember,
  } = audit

  const { relationship_type } = auditedChanges

  if (relationship_type === "assignee") {
    return (
      <div>
        Unassigned and removed&nbsp;
        <span className="font-semibold">{taskAssignee.fullName}</span> from <TaskLink task={task} formSubmissionSlug={formSubmissionSlug} />.
      </div>
    )
  }

  if (relationship_type === "member") {
    return (
      <div>
        Removed&nbsp;
        <span className="font-semibold">{taskMember.fullName}</span> from <TaskLink task={task} formSubmissionSlug={formSubmissionSlug} />.
      </div>
    )
  }

  return (
    <div>
      Removed a user from <TaskLink task={task} formSubmissionSlug={formSubmissionSlug} />.
    </div>
  )
}

TaskUserRemovedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default TaskUserRemovedAuditItemDetails
